module.exports = __webpack_public_path__ + "static/media/HCMM156.5dc18ff4.jpg";